import { Group, Section } from "anketa-core/group";
import { Translation } from "anketa-core/i18n";
import { OpenQuestion } from "anketa-core/open_question";
import { OptionsQuestion } from "anketa-core/options_question";
import { TextValidator } from "anketa-core/validation";

export const setupFortiGateGroup = (fortiGateScanners: Section, idx = 0) => {
  const fortiGateGroup = fortiGateScanner(idx);
  fortiGateScanners.addChild(fortiGateGroup.fortiScanner);

  function onConfigChange() {
    const name = fortiGateGroup.fortiName.fact.raw;

    if (name && name.toString().trim() !== "") {
      fortiGateGroup.fortiName.removeChangeListener(onConfigChange);
      setupFortiGateGroup(fortiGateScanners, idx + 1);
    }
  }

  fortiGateGroup.fortiName.addChangeListener(onConfigChange);
};

export const fortiGateScanner = (
  idx: number
): { fortiScanner: Group; fortiName: OpenQuestion } => {
  const idPrefix = `forti_scanner_${idx}`;

  const fortiScanner = new Group(idPrefix, [
    new Translation("en", "Unconfigured FortiGate Scanner"),
    new Translation("de", "Unkonfigurierter FortiGate Scanner"),
  ]);

  const name = new OpenQuestion(`${idPrefix}_name`, [
    new Translation("en", "Display name"),
    new Translation("de", "Anzeigename"),
  ]);
  name.validator = new TextValidator();
  name.required = true;
  name.addChangeListener(() => {
    const plainName = name.fact.raw.toString();
    if (plainName.trim() !== "") {
      fortiScanner.title = [
        new Translation("en", plainName),
        new Translation("de", plainName),
      ];
    } else {
      fortiScanner.title = [
        new Translation("en", "Unconfigured FortiGate Scanner"),
        new Translation("de", "Unkonfigurierter FortiGate Scanner"),
      ];
    }
  });
  fortiScanner.addChild(name);

  const hostname = new OpenQuestion(`${idPrefix}_hostname`, [
    new Translation("en", "FortiGate Hostname"),
    new Translation("de", "FortiGate-Hostname"),
  ]);
  hostname.validator = new TextValidator();
  hostname.required = true;
  hostname.help = [
    new Translation(
      "en",
      "IP/FQDN of the FortiGate device (e.g., 192.168.1.1)"
    ),
    new Translation("de", "IP/FQDN des FortiGate-Geräts (z.B., 192.168.1.1)"),
  ];
  fortiScanner.addChild(hostname);

  const token = new OpenQuestion(`${idPrefix}_token`, [
    new Translation("en", "API Token"),
    new Translation("de", "API-Token"),
  ]);
  token.required = true;
  token.readonly = true;
  token.help = [
    new Translation("en", "Authentication token for API access"),
    new Translation("de", "Authentifizierungstoken für API-Zugriff"),
  ];
  fortiScanner.addChild(token);

  const vdom = new OpenQuestion(`${idPrefix}_vdom`, [
    new Translation("en", "Virtual Domain (VDOM)"),
    new Translation("de", "Virtuelle Domain (VDOM)"),
  ]);
  vdom.help = [
    new Translation("en", "Specify VDOM for multi-domain configurations"),
    new Translation("de", "VDOM für Multi-Domain-Konfigurationen angeben"),
  ];
  vdom.validator = new TextValidator();

  fortiScanner.addChild(vdom);

  const insecure = new OptionsQuestion(
    `${idPrefix}_insecure`,
    [
      new Translation("en", "Disable Certificate Verification"),
      new Translation("de", "Zertifikatsüberprüfung deaktivieren"),
    ],
    "default.options.yes_no"
  );
  insecure.help = [
    new Translation("en", "Bypass SSL/TLS certificate validation"),
    new Translation("de", "SSL/TLS-Zertifikatsvalidierung umgehen"),
  ];
  if (insecure.fact.raw === null) {
    insecure.setFactValue(1);
  }
  fortiScanner.addChild(insecure);

  return { fortiScanner, fortiName: name };
};
